// extracted by mini-css-extract-plugin
export var container = "SplitContainer-module--container--3BfeK";
export var col = "SplitContainer-module--col--E5g8t";